import { fetchStatsDefinitions } from '@apis/statistics';
import LivePolling from '@live/pollingHandler';
import type { Match } from '@shared-types/match.types';
import type { Statistic } from '@shared-types/stats.types';
import { getRefreshRate } from '@utilities/live';
import { getStatNumericValue } from '@utilities/stats';

export type LiveStatsPluginOptions = {
  matchEntity?: Match;
};

const defaults: LiveStatsPluginOptions = {};
export default class LiveStatsPlugin {
  opt: LiveStatsPluginOptions;
  dom: HTMLElement;
  elements: HTMLPkListStatItemElement[];
  pollingUrl: string;

  constructor(dom: HTMLElement, options: LiveStatsPluginOptions) {
    this.opt = {
      ...defaults,
      ...options,
    };

    this.dom = dom;
    this.elements = Array.from(this.dom.querySelectorAll<HTMLPkListStatItemElement>('.js-live-stat'));
    this.pollingUrl = `${window.matchStatsApiUrl}v1/team-statistics/${this.opt.matchEntity.id}`;
  }

  init() {
    const interval = getRefreshRate(this.opt.matchEntity);

    LivePolling.on(this.pollingUrl, [{ key: 'x-api-key', value: window.apiKey }], interval, this.onUpdate, this);
  }

  detach() {
    LivePolling.off(this.pollingUrl, this.onUpdate, this);
  }

  onUpdate = async (data: Statistic[]) => {
    const home = data.find(({ teamId }) => teamId === this.opt.matchEntity.homeTeam.id);
    const away = data.find(({ teamId }) => teamId === this.opt.matchEntity.awayTeam.id);

    const definitions = await fetchStatsDefinitions();

    this.elements.forEach((element) => {
      const statType = definitions?.find((sd) => sd.name === element.dataset.statType);

      element.data = getStatNumericValue(home, statType);
      element.secondData = getStatNumericValue(away, statType);
    });
  };
}
